module.exports = {
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    debounce: function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    setResizeDebounce: function(func, wait, immediate) {
        wait = wait || 250;
        immediate = immediate || false;
        var thisD = this;
        var debouncedFunc = thisD.debounce(func, wait, immediate);
        $(window).resize(debouncedFunc);
    }
};



// WEBPACK FOOTER //
// ./modules/debounce.js